import { styled } from 'components/ThemeConfigConnector/ThemeConfigConnnector';
import { subtitleStyles, titleStyles, visuallyHidden } from 'style/styled-components/cssHeadings';

export const PageHeading = styled.h1<{ srOnly?: boolean; looksLike?: 'title' | 'subtitle' }>`
    ${(props) => (props.looksLike === 'subtitle' ? subtitleStyles : titleStyles)}
    ${(props) => props.srOnly && visuallyHidden}
`;
